<script lang="ts">
    import EventsEmptyStateIcon from '../../icons/EventsEmptyStateIcon.svelte';

    export let title = '';
    export let description = '';
    export let testId = 'events-empty-state';
</script>

<div
    class="flex flex-col items-center justify-center text-center px-4 py-12 text-gray-600"
    data-testid={testId}
>
    <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-6">
        <EventsEmptyStateIcon width="40" height="40" color="#0f766e" />
    </div>
    {#if title}
        <h2 class="!text-xl !leading-7 !font-semibold !text-gray-800">{title}</h2>
    {/if}
    {#if description}
        <p class="mt-2 !text-sm !leading-6 !text-gray-500">{description}</p>
    {/if}
</div>
